export const VIEWBOXES = {
  _24: '0 0 24 24',
  _16: '0 0 16 16'
};
//# sourceMappingURL=consts.js.map